import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  width: 100%;
  padding-top: 40px;
  color: ${colors.footerText};
  background-color: ${colors.backgroundBody};
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 17px;

  .container {
    width: 80%;
    min-height: 400px;
    margin: 0 auto;
  }
  .logo-container {
    position: relative;

    @media (min-width: 1023px) {
      left: -60px;
    }
  }

  .abo-link {
    text-decoration: none;
    color: ${colors.footerText};
    padding: 0 !important;
  }

  .description {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .column-container {
    min-height: 260px;

    @media (min-width: 1023px) {
      display: flex;
    }

    @media (max-width: 1023px) {
      min-height: initial;
    }
  }

  .column {
    border-left: 1px solid gray;
    padding-left: 15px;

    @media (max-width: 1023px) {
      border-top: 1px solid gray;
      border-left: 0;
      padding-top: 22px;
      margin-top: 22px;
      padding-left: 0px;
      text-align: center;
    }
  }

  .first-column {
    & .icon-container {
      display: flex;
      margin-top: 20px;
      margin-bottom: 40px;
    }

    & a {
      padding: 10px;
    }

    & path {
      fill: ${colors.footerLogo};
    }
  }

  .second-column {
    margin-left: 25%;

    a {
      color: ${colors.footerText};
      display: block;
      margin-bottom: 15px;
      text-decoration: none;
      white-space: nowrap;
    }

    @media (max-width: 1023px) {
      margin: auto;
      margin-top: 22px;
    }
  }

  .icon-container {
    @media (max-width: 1023px) {
      max-width: 280px;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: auto;

      > a {
        width: 40px;
      }
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Footer/style.js